import { render, staticRenderFns } from "./LeaderboardLockedPlayerComponent.vue?vue&type=template&id=18c72c99&scoped=true&"
import script from "./LeaderboardLockedPlayerComponent.vue?vue&type=script&lang=ts&"
export * from "./LeaderboardLockedPlayerComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderboardLockedPlayerComponent.vue?vue&type=style&index=0&id=18c72c99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c72c99",
  null
  
)

export default component.exports